import React from 'react'
import {Divider, Row} from "antd";

const AboutGameCard = ({
    title='ABOUT GAME',
    items = [],
    ...props
})=>{

    return (
        <div className={'border'}>
        <h3 className={'padding-sm primary50-bg'} >{title}</h3>
            {
                items.map((item)=><><Row justify={'space-between'} className={'padding-sm white60'}>
                    <span className={'bold'}>{item.name}</span>
                    <span>{item.value}</span>
                </Row>
                    <Divider className={'no-margin'} />
                </>
                )
            }
        </div>
    )
}

export default AboutGameCard